/**
 * Auth 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {AUTH_QUERY_KEY_MAP} from '../api/auth/constant';
import {authFactory} from '../factory/authFactory';

// ============================================
// useActivateUserQuery
// ============================================

export function useActivateUserQuery(
  ...args: Parameters<typeof authFactory.activateUser>
) {
  return useQuery(authFactory.activateUser(...args));
}

useActivateUserQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.activateUser>
) => [...AUTH_QUERY_KEY_MAP.activateUser(...args)];

// ============================================
// useAgreementsQuery
// ============================================

export function useAgreementsQuery(
  ...args: Parameters<typeof authFactory.agreements>
) {
  return useQuery(authFactory.agreements(...args));
}

useAgreementsQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.agreements>
) => [...AUTH_QUERY_KEY_MAP.agreements(...args)];

// ============================================
// useCheckUnregisterQuery
// ============================================

export function useCheckUnregisterQuery(
  ...args: Parameters<typeof authFactory.checkUnregister>
) {
  return useQuery(authFactory.checkUnregister(...args));
}

useCheckUnregisterQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.checkUnregister>
) => [...AUTH_QUERY_KEY_MAP.checkUnregister(...args)];

// ============================================
// useGetGlobalAgreementsQuery
// ============================================

export function useGetGlobalAgreementsQuery(
  ...args: Parameters<typeof authFactory.getGlobalAgreements>
) {
  return useQuery(authFactory.getGlobalAgreements(...args));
}

useGetGlobalAgreementsQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.getGlobalAgreements>
) => [...AUTH_QUERY_KEY_MAP.getGlobalAgreements(...args)];

// ============================================
// useGetGlobalParentVerificationIsCompletedQuery
// ============================================

export function useGetGlobalParentVerificationIsCompletedQuery(
  ...args: Parameters<typeof authFactory.getGlobalParentVerificationIsCompleted>
) {
  return useQuery(authFactory.getGlobalParentVerificationIsCompleted(...args));
}

useGetGlobalParentVerificationIsCompletedQuery.getKey = (
  ...args: Parameters<
    typeof AUTH_QUERY_KEY_MAP.getGlobalParentVerificationIsCompleted
  >
) => [...AUTH_QUERY_KEY_MAP.getGlobalParentVerificationIsCompleted(...args)];

// ============================================
// usePrepareAuthRequestInfoQuery
// ============================================

export function usePrepareAuthRequestInfoQuery(
  ...args: Parameters<typeof authFactory.prepareAuthRequestInfo>
) {
  return useQuery(authFactory.prepareAuthRequestInfo(...args));
}

usePrepareAuthRequestInfoQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.prepareAuthRequestInfo>
) => [...AUTH_QUERY_KEY_MAP.prepareAuthRequestInfo(...args)];

// ============================================
// useSelfCertAgreementQuery
// ============================================

export function useSelfCertAgreementQuery(
  ...args: Parameters<typeof authFactory.selfCertAgreement>
) {
  return useQuery(authFactory.selfCertAgreement(...args));
}

useSelfCertAgreementQuery.getKey = (
  ...args: Parameters<typeof AUTH_QUERY_KEY_MAP.selfCertAgreement>
) => [...AUTH_QUERY_KEY_MAP.selfCertAgreement(...args)];
